import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const Wrapper = styled.div`
  width: 100%;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  box-shadow: ${tokens.shadow.card};
  overflow: hidden;
`

export const ScrollArea = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: ${tokens.font.body};
  color: ${tokens.text.primary};
`

export const HeaderRow = styled.tr`
  background: rgba(255, 255, 255, 0.025);
`

export const BodyRow = styled.tr<{ $clickable?: boolean }>`
  background: transparent;
  cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
  transition: background ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    background: rgba(255, 255, 255, 0.045);
  }
  &:last-child td {
    border-bottom: none;
  }
`

interface CellProps {
  $align?: 'left' | 'center' | 'right'
  $sortable?: boolean
}

export const Th = styled.th<CellProps>`
  text-align: ${(p) => p.$align ?? 'left'};
  padding: 0.85rem 1.15rem;
  font-size: ${tokens.font.micro};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: ${tokens.text.muted};
  background: rgba(255, 255, 255, 0.025);
  border-bottom: 1px solid ${tokens.border.strong};
  cursor: ${(p) => (p.$sortable ? 'pointer' : 'default')};
  user-select: none;
  white-space: nowrap;
`

export const StickyTh = styled(Th)`
  position: sticky;
  left: 0;
  z-index: 2;
`

export const Td = styled.td<CellProps>`
  text-align: ${(p) => p.$align ?? 'left'};
  padding: 0.9rem 1.15rem;
  border-bottom: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.primary};
  vertical-align: middle;
`

export const StickyTd = styled(Td)`
  position: sticky;
  left: 0;
  z-index: 1;
`

export const SortIndicator = styled.span`
  margin-left: 0.4rem;
  font-size: 0.7rem;
  color: ${tokens.accent.onDark};
`

export const CompactTh = styled(Th)`
  width: 3rem;
  min-width: 3rem;
  max-width: 3rem;
  padding: 0;
`

export const MenuCell = styled.td`
  position: relative;
  z-index: 10;
  border-bottom: 1px solid ${tokens.border.hairline};
  vertical-align: middle;
  width: 3rem;
  padding: 0;
`

export const EmptyCell = styled.td`
  text-align: center;
  padding: 2rem;
  color: ${tokens.text.muted};
`

export const TableControls = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 0.25rem;
`

export const ToggleWrapper = styled.div`
  position: relative;
`

export const ColumnsButton = styled.button`
  background: none;
  border: none;
  color: ${tokens.accent.onDark};
  font-size: ${tokens.font.body};
  font-weight: 500;
  cursor: pointer;
  padding: 0.25rem 0.5rem;

  &:hover {
    text-decoration: underline;
  }
`

export const ColumnsDropdown = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 0.5rem;
  z-index: 100;
  min-width: 14rem;
  padding: 0.75rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background-color: ${tokens.surface.raised};
  box-shadow: ${tokens.shadow.card};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const ShowAllButton = styled.button`
  background: none;
  border: none;
  color: ${tokens.accent.onDark};
  font-size: ${tokens.font.body};
  font-weight: 500;
  cursor: pointer;
  padding: 0.75rem 0.5rem;
  text-align: left;
  border-bottom: 1px solid ${tokens.border.hairline};
  margin-bottom: 0.25rem;
`

export const ColumnToggleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.5rem;
  cursor: pointer;
  border-radius: ${tokens.radius.chip};
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};

  &:hover {
    background-color: ${tokens.surface.inset};
  }
`

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
  min-width: 12rem;
`

export const RightCell = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  white-space: nowrap;
`

export const RowMenuPanel = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  max-height: 12.5rem;
  border: 1px solid ${tokens.border.hairline};
  background-color: ${tokens.surface.raised};
  box-shadow: ${tokens.shadow.card};
  padding: 0.625rem;
  width: 10rem;
  border-radius: ${tokens.radius.control};
`

export const RowMenuOption = styled.div`
  cursor: pointer;
  height: 2.5rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  border-radius: ${tokens.radius.chip};
  padding: 0 0.5rem;

  &:hover {
    background-color: ${tokens.surface.inset};
  }

  p {
    font-size: 12px;
    line-height: 16px;
  }
`
